import { api } from './api';

export interface AccountMatch {
  accountId: string;
  code: string;
  label: string;
  category: string | null;
  score: number | null;
}

export interface SearchAccountsResult {
  mode: 'semantic' | 'lexical' | 'disabled';
  results: AccountMatch[];
}

export interface AccountLite {
  accountId: string;
  code: string;
  label: string;
}

export interface DuplicatesResult {
  mode: 'semantic' | 'lexical';
  clusters: AccountLite[][];
}

export const semanticApi = {
  async searchAccounts(workspaceId: string, q: string, limit = 10): Promise<SearchAccountsResult> {
    const r = await api.get<SearchAccountsResult>(`/api/workspaces/${workspaceId}/semantic/accounts`, {
      params: { q, limit },
    });
    return r.data;
  },
  async reindexAccounts(workspaceId: string): Promise<{ mode: string; indexed: number }> {
    const r = await api.post<{ mode: string; indexed: number }>(
      `/api/workspaces/${workspaceId}/semantic/accounts/reindex`,
      {},
    );
    return r.data;
  },
  async findDuplicates(workspaceId: string): Promise<DuplicatesResult> {
    const r = await api.get<DuplicatesResult>(
      `/api/workspaces/${workspaceId}/semantic/accounts/duplicates`,
    );
    return r.data;
  },
};
